'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _flatten = require('lodash/flatten');

var _flatten2 = _interopRequireDefault(_flatten);

var _compose = require('lodash/fp/compose');

var _compose2 = _interopRequireDefault(_compose);

var _isArray = require('lodash/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _ajax = require('rxjs/observable/dom/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _empty = require('rxjs/observable/empty');

var _empty2 = _interopRequireDefault(_empty);

var _of = require('rxjs/observable/of');

var _of2 = _interopRequireDefault(_of);

require('rxjs/add/operator/catch');

require('rxjs/add/operator/mergeMap');

require('rxjs/add/operator/filter');

var _agent = require('./agent');

var _agent2 = _interopRequireDefault(_agent);

var _url = require('./url');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapResults = function mapResults(result) {
  return (0, _isArray2.default)(result) ? result : [result];
};
var toActionObservable = (0, _compose2.default)(function (actions) {
  return _of2.default.of.apply(_of2.default, (0, _toConsumableArray3.default)(actions));
}, _flatten2.default);

var handleSuccess = function handleSuccess(ajaxResponse, mapSuccess) {
  if (typeof mapSuccess === 'function') {
    return _of2.default.of.apply(_of2.default, (0, _toConsumableArray3.default)(mapResults(mapSuccess(ajaxResponse && ajaxResponse.response))));
  }

  return _empty2.default.empty();
};

var handleFailure = function handleFailure(error) {
  for (var _len = arguments.length, mapFailures = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    mapFailures[_key - 1] = arguments[_key];
  }

  return toActionObservable(mapFailures.filter(function (mf) {
    return mf && typeof mf === 'function';
  }).map(function (mf) {
    return mf(error);
  }));
};

var configAjax = function configAjax() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { defaultConfig: {} },
      prefix = _ref.prefix,
      error = _ref.error,
      _ref$defaultConfig = _ref.defaultConfig,
      defaultConfig = _ref$defaultConfig === undefined ? {} : _ref$defaultConfig;

  var ajax = function ajax(_ref2) {
    var config = _ref2.config,
        mapSuccess = _ref2.mapSuccess,
        mapFailure = _ref2.mapFailure;

    return _ajax2.default.ajax((0, _extends3.default)({}, defaultConfig, config, {
      headers: (0, _extends3.default)({}, defaultConfig.headers || {}, config.headers || {}),
      url: (0, _url.appendPath)(prefix, config.url),
      responseType: config.responseType || defaultConfig.responseType || 'json'
    })).mergeMap(function (ajaxResponse) {
      return handleSuccess(ajaxResponse, mapSuccess);
    }).filter(function (a) {
      return a;
    }).catch(function (e) {
      return handleFailure(e, error, mapFailure);
    });
  };

  var prepareConfig = function prepareConfig(config) {
    var ajaxConfig = typeof config === 'string' ? { url: config } : config;

    if (!ajaxConfig.url) throw new Error('please set url when use http request');

    return ajaxConfig;
  };

  var appendRandomParam = function appendRandomParam(urlString) {
    return (0, _url.appendParam)(urlString, '_', Math.random().toString().slice(2));
  };

  /**
   * send a GET HTTP Request
   * @param url
   * @param mapSuccess [mapSuccess] - map success response to action
   * @param mapFailure [mapFailure] - map error to action
   * @param customConfig
   * @return {Observable}
   */
  var get = function get(config) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        mapSuccess = _ref3.mapSuccess,
        mapFailure = _ref3.mapFailure;

    var ajaxConfig = prepareConfig(config);

    return ajax({
      config: (0, _extends3.default)({}, ajaxConfig, {
        url: _agent2.default.isIE() ? appendRandomParam(ajaxConfig.url) : ajaxConfig.url,
        method: 'GET'
      }),
      mapSuccess: mapSuccess,
      mapFailure: mapFailure
    });
  };

  /**
   * send a POST HTTP Request
   * @param url url of api
   * @param body request content
   * @param mapSuccess  [mapSuccess] - map success response to action
   * @param mapFailure [mapFailure] - map error to action
   * @param customConfig extend config follow RxJS standard
   * @return {Observable}
   */
  var post = function post(config) {
    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        mapSuccess = _ref4.mapSuccess,
        mapFailure = _ref4.mapFailure;

    if (typeof config === 'string') {
      throw new Error('please set config as a object in post method');
    }

    var autoContentType = config.autoContentType,
        ajaxConfig = (0, _objectWithoutProperties3.default)(config, ['autoContentType']);


    if (ajaxConfig.headers !== null) {
      ajaxConfig.headers = ajaxConfig.headers || {};

      if (!autoContentType) {
        ajaxConfig.headers['Content-Type'] = ajaxConfig.headers['Content-Type'] || 'application/json;charset=UTF-8';
      }
    }

    return ajax({
      config: (0, _extends3.default)({}, ajaxConfig, {
        method: 'POST'
      }),
      mapSuccess: mapSuccess,
      mapFailure: mapFailure
    });
  };

  var del = function del(uri) {
    var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        mapSuccess = _ref5.mapSuccess,
        mapFailure = _ref5.mapFailure;

    var config = prepareConfig(uri);
    return ajax({
      config: (0, _extends3.default)({}, config, {
        method: 'DELETE'
      }),
      mapSuccess: mapSuccess,
      mapFailure: mapFailure
    });
  };

  var put = function put(config) {
    var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        mapSuccess = _ref6.mapSuccess,
        mapFailure = _ref6.mapFailure;

    if (typeof config === 'string') {
      throw new Error('please set config as a object in put method');
    }

    var ajaxConfig = config;
    ajaxConfig.headers = ajaxConfig.headers || {};
    ajaxConfig.headers = (0, _extends3.default)({}, ajaxConfig.headers, {
      'Content-Type': ajaxConfig.headers['Content-Type'] || 'application/json;charset=UTF-8'
    });
    return ajax({
      config: (0, _extends3.default)({}, ajaxConfig, {
        method: 'PUT'
      }),
      mapSuccess: mapSuccess,
      mapFailure: mapFailure
    });
  };

  return {
    get: get,
    post: post,
    del: del,
    put: put
  };
};

exports.default = configAjax;